<!-- FEITO -->
<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.status"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                        <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="item.allowDestroy && item.id != null"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>

// Components.
import Modal from './Modal'

export default {
    components: { Modal },
    data: () => ({
        fields: [
            { key: 'nomeStatus', label: 'Nome', sortable: true },
            { key: 'tipoStatusNome', label: 'Tipo', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(status) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o status?',
                async () => this.data.model.status.splice(this.data.model.status.indexOf(status), 1)
            )
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>